import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@Services/redux/Store';
import { IProcess } from './Interfaces';
import { initialProcessState } from './State';

const ProcessSlice = createSlice({
    name: 'Process',
    initialState: initialProcessState,
    reducers: {
        updateProcesses(state, action) {
            state.processes = action.payload;
        },
        setProcess(state, action) {
            state.selectedProcess = action.payload;
        },
        initialisePayloadData(state, action) {
            state.proccessPayloadInputs = action.payload;
        },
        addPayloadDataEntry(state, action) {
            const inputIndex = state.proccessPayloadInputs.findIndex(
                (i) => i.id === action.payload.inputId
            );
            if (inputIndex > -1) {
                const updatedInput = {
                    ...state.proccessPayloadInputs[inputIndex],
                };
                updatedInput.values.push(undefined);
                state.proccessPayloadInputs[inputIndex] = updatedInput;
            }
        },
        removePayloadDataEntry(state, action) {
            const inputIndex = state.proccessPayloadInputs.findIndex(
                (i) => i.id === action.payload.inputId
            );
            if (inputIndex > -1) {
                const updatedInput = {
                    ...state.proccessPayloadInputs[inputIndex],
                };
                updatedInput.values.splice(action.payload.valueIndex, 1);
                state.proccessPayloadInputs[inputIndex] = updatedInput;
            }
        },
        setPayloadDataAttribute(state, action) {
            const inputIndex = state.proccessPayloadInputs.findIndex(
                (i) => i.id === action.payload.inputId
            );
            if (inputIndex > -1) {
                const updatedInput = {
                    ...state.proccessPayloadInputs[inputIndex],
                };
                updatedInput.values[action.payload.valueIndex] =
                    action.payload.value;
                state.proccessPayloadInputs[inputIndex] = updatedInput;
            }
        },
        initialiseRunningProcesses(state, action) {
            state.runningProcesses = action.payload;
            state.hasProgressStateLoaded = true;
        },
        addRunningProcess(state, action) {
            state.runningProcesses.push(action.payload);
        },
        OLDsetPayloadDataAttribute(state, action) {
            state.OLDpayloadData[action.payload.attribute] =
                action.payload.value;
        },
        OLDinitialisePayloadData(state, action) {
            state.OLDpayloadData = action.payload;
        },
    },
});

export const ProcessActions = ProcessSlice.actions;

const processesState = (state: RootState): IProcess[] =>
    state.process.processes;

export const filteredProcessesState = createSelector(
    processesState,
    (processes) => processes.filter((p) => p.is_exposed)
);

export const linkDepartmentProcessState = createSelector(
    processesState,
    (processes) => {
        const filteredProcesses = processes.filter(
            (p) => p.process_name === 'link ike office images'
        );
        return filteredProcesses.length > 0 ? filteredProcesses[0] : null;
    }
);

export const iiqAutomationTaskState = createSelector(
    processesState,
    (processes) => {
        const iiqAutomationTask = processes.filter(
            (p) => p.process_identifier_name === 'run_iiq_automation_task'
        );
        return iiqAutomationTask.length > 0 ? iiqAutomationTask[0] : null;
    }
);

export const selectedProcessState = (state: RootState) =>
    state.process.selectedProcess;

export const proccessPayloadInputsState = (state: RootState) =>
    state.process.proccessPayloadInputs;

export const runningProcessesState = (state: RootState) =>
    state.process.runningProcesses;

export const hasProgressStateLoadedState = (state: RootState) =>
    state.process.hasProgressStateLoaded;

export const OLDPayloadDataState = (state: RootState) =>
    state.process.OLDpayloadData;

export default ProcessSlice.reducer;
